module.exports = __webpack_public_path__ + "static/media/maritimo.1b234be8.png";